"use client"
import Link from "next/link"
import { useEffect } from "react"
import { TelegramIcon, TwitterIcon } from "@abraxas/ui/icons"
import { Button } from "@abraxas/ui/ui"

type FooterLink = {
  href: string
  label: string
}

type SocialLink = {
  href: string
  Icon: React.ComponentType<{ className?: string }>
}

const socialLinks: SocialLink[] = [
  {
    href: "https://x.com/loomlocknft",
    Icon: TwitterIcon,
  },
  // {
  //   href: "mailto:info@loomlock.com",
  //   Icon: MailIcon,
  // },
  {
    href: "https://t.me/loomlockupdates",
    Icon: TelegramIcon,
  },
]

// we'll want this eventually
const _footerLinks: FooterLink[] = [
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/terms", label: "Terms of Service" },
  { href: "/cookies", label: "Cookie Policy" },
]

const SocialLinks = () => (
  <div className="flex flex-wrap gap-[12px]">
    {socialLinks.map((link) => (
      <Link
        key={link.href}
        href={link.href}
        className="bg-brand-blue-200 overflow-clip relative rounded-[12px] shrink-0 size-[44px] flex items-center justify-center text-brand-blue-600 hover:bg-brand-blue-300 transition-colors"
      >
        <link.Icon className="w-5 h-5" />
      </Link>
    ))}
  </div>
)

export default function Footer() {
  useEffect(() => {
    // setting overscroll color to match the footer's white
    const setBgColor = () => {
      if (!document.body.parentElement) {
        return
      }
      if (window.scrollY > 100) {
        document.body.parentElement!.style.backgroundColor = "#FFFFFF"
      } else {
        document.body.parentElement!.style.backgroundColor =
          "var(--color-brand)"
      }
    }
    document.addEventListener("scroll", setBgColor)
    return () => document.removeEventListener("scroll", setBgColor)
  }, [])

  return (
    <footer className="bg-white w-full relative text-brand-blue-500 py-10">
      <div className="container">
        <div className="mx-auto flex flex-col gap-[24px]">
          {/* Logo and Get in touch section */}
          <div className="flex flex-col gap-6 pb-6 justify-between">
            <div className="flex flex-col md:flex-row gap-6 justify-between">
              <div className="flex-1 flex flex-col gap-3 pr-5 grow">
                <img
                  src="/images/logos/logo-black.svg"
                  alt="Loomlock"
                  className="h-[51px] w-[190px] object-contain "
                />
                <p className="text-body-xs font-medium max-w-md">
                  Lock away distractions. Unlock your potential. Transform your
                  life one focused moment at a time.
                </p>
              </div>
              <div className="flex-1 flex flex-col md:flex-row gap-8 justify-between max-w-xl pt-2 justify-end">
                {/* <div className="flex-1 flex flex-col gap-4">
              <p className="text-body-s font-semibold">Product</p>
              <div className="flex flex-col gap-3 text-body-xs font-medium">
                <p>About Us</p>
                <p>Gift a Loomlock</p>
                <p>Pre-order</p>
              </div>
            </div>
            <div className="flex-1 flex flex-col gap-4">
              <p className="text-body-s font-semibold">Support</p>
              <div className="flex flex-col gap-3 text-body-xs font-medium">
                <p>Help Center</p>
                <p>Community</p>
                <p>Contact Us</p>
              </div>
            </div> */}
                <div className="flex flex-col gap-4">
                  <p className="text-body-s font-semibold">Get in touch</p>
                  <SocialLinks />
                </div>
              </div>
            </div>
            <div>
              <Button
                href="https://loomlock.com"
                target="_blank"
                className="text-white border-none shadow-lg"
                style={{
                  backgroundImage:
                    "linear-gradient(180deg, #3F49CC 39.49%, #202566 100%)",
                }}
              >
                Visit loomlock.com
              </Button>
            </div>
          </div>

          {/* Divider */}
          {/* <div className="h-0 relative shrink-0 w-full">
            <div className="absolute inset-0 border-t border-brand-blue-600" />
          </div> */}

          {/* Bottom section */}
          {/* <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-[16px]">
            <p className="font-medium text-[14px] leading-[20px] text-brand-blue-500 font-montserrat">
              2025 Loomlock. All rights reserved
            </p>

            <div className="flex flex-wrap gap-[21px] items-center">
              {footerLinks.map((link) => (
                <Link
                  key={link.href}
                  href={link.href}
                  className="font-medium text-[14px] leading-[20px] text-brand-blue-500 hover:text-brand-blue-400 transition-colors font-montserrat"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </footer>
  )
}
